import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hero is-fullheight p-6" }
const _hoisted_2 = { class: "container has-background-light is-flex is-flex-direction-column is-justify-content-center is-align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "title is-4",
  style: {"text-align":"center"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = { class: "select is-info" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "control has-icons-left has-icons-right" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "control has-icons-left" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "control has-text-centered" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = { class: "control has-text-centered" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = { class: "control has-text-centered has-text-black" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = { class: "control has-text-centered has-text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _ctx.logoPath,
          class: "image mb-4",
          style: {"width":"70%","margin":"auto"},
          alt: "logo"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('Customer.VideoAppointment')), 1),
      (_ctx.showLanguageSwitcher)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeLanguage && _ctx.changeLanguage(...args)))
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("option", { value: "en" }, "en", -1),
                  _createElementVNode("option", { value: "pt-BR" }, "pt-BR", -1),
                  _createElementVNode("option", { value: "pt" }, "pt", -1)
                ]), 544), [
                  [_vModelSelect, _ctx.selectedLanguage]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"])),
        class: "p-3"
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "email",
              placeholder: _ctx.$t('General.EmailPlaceholder'),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
              required: ""
            }, null, 8, _hoisted_10), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              placeholder: _ctx.$t('General.PasswordPlaceholder'),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
              required: ""
            }, null, 8, _hoisted_13), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-success is-fullwidth", { 'is-loading': _ctx.isChecking }])
            }, _toDisplayString(_ctx.$t('General.Login')), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-success is-fullwidth is-light", { 'is-loading': _ctx.isChecking }])
            }, [
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.registerCustomer && _ctx.registerCustomer(...args)))
              }, _toDisplayString(_ctx.$t('Customer.NewCustomer')), 1)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("p", _hoisted_19, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToResetPassword && _ctx.goToResetPassword(...args)))
            }, _toDisplayString(_ctx.$t('General.ResetPassword')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("p", _hoisted_21, [
            _createElementVNode("a", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openHomeWebSite && _ctx.openHomeWebSite(...args)))
            }, _toDisplayString(_ctx.$t('General.BackToWebSite')), 1)
          ])
        ])
      ], 32)
    ])
  ]))
}